import { render } from "./AlertBanner.vue?vue&type=template&id=7f84ab4e&scoped=true&ts=true"
import script from "./AlertBanner.vue?vue&type=script&lang=ts"
export * from "./AlertBanner.vue?vue&type=script&lang=ts"

import "./AlertBanner.vue?vue&type=style&index=0&id=7f84ab4e&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f84ab4e"]])

export default __exports__